import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { alertCompleted, alertError, alertBeforeHandle } from '../../utils'
import { moveOrderToIssue } from '../../Services/serviceAdmin'
import Colors from '../../../../constants/Colors'

const OrderIssueButton = ({ order, fetchOrdersByStatus }) => {
  const dispatch = useDispatch()

  const moveToIssue = async () => {
    dispatch({ type: 'loading_show' })
    const body = { orderId: order?.id }
    const response = await moveOrderToIssue(body)
    dispatch({ type: 'loading_hide' })
    if (response.success) {
      await alertCompleted()
      dispatch({ type: 'loading_show' })
      await fetchOrdersByStatus('CONFIRMED', true)
      dispatch({ type: 'loading_hide' })
    } else {
      alertError()
    }
  }

  return (
    <Container onClick={() => alertBeforeHandle('ย้ายไปยังส่วนที่มีปัญหา', moveToIssue)}>
      ย้ายไปยังส่วนที่มีปัญหา
    </Container>
  )
}

export default OrderIssueButton

const Container = styled.div`
  font-size: 16px;
  padding: 10px;
  &:hover {
    cursor: pointer;
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }
  box-shadow: rgba(0, 0, 0, 0.8) 1.95px 1.95px 2.6px;
  color: ${Colors.WHITE};
  background-color: ${Colors.LIGHT_RED};
`
